// 弹题渲染宿主页 postMessage 协议（v1.1 Tier 2 沙箱件同套字段命名，见 src/contract.md 引用方）
// 零依赖纯函数：parseInit 供宿主页解析 parent 发来的 init 消息，buildReply 统一出站消息形状。
// 本文件不 import Vue/@saas/*，供 web 宿主页与未来 WebView(Tier 2) 宿主复用。

export const MSG_TYPES = {
  INIT: 'quiz:init',
  READY: 'quiz:ready',
  SESSION_CHANGED: 'quiz:session-changed',
  ERROR: 'quiz:error'
}

// parseInit(event, allowedOrigins) -> {ok:true, payload} | {ok:false, reason}
// - origin 必须 ∈ allowedOrigins（调用方负责把 window.location.origin 并入白名单）
// - event.data.type 必须是 'quiz:init'
// - payload.typeKey / payload.view 必存
export function parseInit (event, allowedOrigins) {
  const allowed = Array.isArray(allowedOrigins) ? allowedOrigins : Array.from(allowedOrigins || [])
  if (!event || !allowed.includes(event.origin)) {
    return { ok: false, reason: 'origin' }
  }
  const data = event.data
  if (!data || data.type !== MSG_TYPES.INIT) {
    return { ok: false, reason: 'type' }
  }
  const payload = data.payload
  if (!payload || !payload.typeKey || !payload.view) {
    return { ok: false, reason: 'payload' }
  }
  return { ok: true, payload }
}

// buildReply(type, payload?) -> {type} | {type, payload}
export function buildReply (type, payload) {
  return payload === undefined ? { type } : { type, payload }
}
